import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-preview-confirmation-form',
  templateUrl: './preview-confirmation-form.component.html',
  styleUrls: ['./preview-confirmation-form.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class PreviewConfirmationFormComponent implements OnInit {
  @Input() heading!: string;
  @Input() optionsLabel!: string;
  @Input() optionsPlaceholder!: string;
  @Input() optionsList: any;
  @Input() textareaLabel?: string;
  @Input() textareaPlaceholder?: string;
  @Input() showTextArea!: boolean;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onConfrimClick = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onCancelClick = new EventEmitter<any>();

  formInvoiceRejection!: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.OnFormGroup();
  }

  get invoiceDenyButtonEnable(): boolean {
    return (
      this.formInvoiceRejection.controls['invoiceRejectionReason'].value !=
        null &&
      this.formInvoiceRejection.controls['invoiceRejectionReason'].value
        .length > 0
    );
  }

  OnFormGroup() {
    this.formInvoiceRejection = this.formBuilder.group({
      invoiceRejectionReason: [''],
      additionalNotesRejectionReason: ['']
    });
  }

  confirmClcik() {
    if (this.formInvoiceRejection.controls['invoiceRejectionReason'].value) {
      const selectedReasons =
        this.formInvoiceRejection.controls['invoiceRejectionReason'].value;
      this.onConfrimClick.emit({
        selectedReasons: selectedReasons,
        additionalNotes:
          this.formInvoiceRejection.controls['additionalNotesRejectionReason']
            .value
      });
      this.formInvoiceRejection.reset();
    }
  }

  cancelClick() {
    this.formInvoiceRejection.reset();
    this.onCancelClick.emit();
  }
}
